import { TableCard } from 'app/components'
import { LogsConsultaListHeader } from './components/header/LogsConsultaListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { LogsConsultaTable } from './table/LogsConsultaTable'

const LogsConsultaList = () => {
  return (
    <TableCard>
      <LogsConsultaListHeader />
      <LogsConsultaTable />
    </TableCard>
  )
}

export const LogsConsultaListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <LogsConsultaList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
